import { render, staticRenderFns } from "./PostAssessment.vue?vue&type=template&id=7bce49ac&scoped=true"
import script from "./PostAssessment.vue?vue&type=script&lang=js"
export * from "./PostAssessment.vue?vue&type=script&lang=js"
import style0 from "./PostAssessment.vue?vue&type=style&index=0&id=7bce49ac&prod&scoped=true&lang=css"
import style1 from "./PostAssessment.vue?vue&type=style&index=1&id=7bce49ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bce49ac",
  null
  
)

export default component.exports